import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { CookiesProvider } from 'react-cookie';
import CampaignEditor from './index';
import LangProvider from '../components/LangProvider';

export default (selector, props, show) => {
  let editorInstance;

  const render = (Component) => {
    ReactDOM.render(
      <AppContainer>
        <CookiesProvider>
          <LangProvider>
            <Component ref={c => { editorInstance = c; }} initProps={props} show={show} />
          </LangProvider>
        </CookiesProvider>
      </AppContainer>,
      document.querySelector(selector),
    );
  };

  render(CampaignEditor);

  if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('./index', () => {
      // eslint-disable-next-line global-require
      const NextComponent = require('./index').default;
      render(NextComponent);
    });
  }

  return () => editorInstance;
};



// WEBPACK FOOTER //
// ./app/Assets/js/features/campaignEditor/renderInto.js